var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactor7X(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17.9099,
    r: 16.5,
    fill: "#67E8F9",
    stroke: "#67E8F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4874 18.0539L14.1514 15.4939H16.6154L13.7354 19.5419C14.3754 20.3419 14.9568 21.1206 15.4794 21.8779C16.0021 22.6352 16.4181 23.3126 16.7274 23.9099H14.1674C14.0821 23.7499 13.9754 23.5526 13.8474 23.3179C13.7194 23.0726 13.5754 22.8219 13.4154 22.5659C13.2554 22.2992 13.0848 22.0379 12.9034 21.7819C12.7328 21.5152 12.5621 21.2752 12.3914 21.0619C12.2314 21.2646 12.0661 21.4886 11.8954 21.7339C11.7354 21.9792 11.5808 22.2299 11.4314 22.4859C11.2821 22.7312 11.1328 22.9766 10.9834 23.2219C10.8448 23.4672 10.7221 23.6966 10.6154 23.9099H8.18344C8.31144 23.6432 8.48744 23.3286 8.71144 22.9659C8.93544 22.6032 9.17544 22.2299 9.43144 21.8459C9.69811 21.4512 9.97544 21.0619 10.2634 20.6779C10.5514 20.2832 10.8341 19.9152 11.1114 19.5739C10.6314 18.9019 10.1514 18.2246 9.67144 17.5419C9.19144 16.8486 8.71677 16.1659 8.24744 15.4939H10.8234L12.4874 18.0539ZM19.1548 23.9099C19.2188 23.1312 19.3521 22.3206 19.5548 21.4779C19.7575 20.6352 20.0028 19.8086 20.2908 18.9979C20.5895 18.1872 20.9201 17.4246 21.2828 16.7099C21.6455 15.9846 22.0135 15.3606 22.3868 14.8379H17.5708V12.8059H25.3308V14.5339C24.9895 14.9072 24.6108 15.4246 24.1948 16.0859C23.7895 16.7472 23.4001 17.4992 23.0268 18.3419C22.6641 19.1739 22.3441 20.0699 22.0668 21.0299C21.8001 21.9899 21.6348 22.9499 21.5708 23.9099H19.1548Z",
    fill: "#2D3344"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactor7X);
export default __webpack_public_path__ + "static/media/factor7x.e1999685b8b56d5ba98ebd2938ec833f.svg";
export { ForwardRef as ReactComponent };